var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"mobile-nav d-lg-none"},[_c('nav-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }